import loadable from '@loadable/component';

// 懒加载组件
const OrderManagement = loadable(() => import('./orderManagement/OrderManagement'));
const OrderManagement2310 = loadable(() => import('./orderManagement2310/OrderManagement'));
const OrderWithUpstreamManagement = loadable(() => import('../supOrder/orderWithUpstreamManagement/OrderManagement'));
const OrderDetailWithUpstreamQuery = loadable(() => import('./orderDetailWithUpstreamQuery/OrderDetailQuery'));

export const subRoutes = [
  {
    // 261001 订单查询响应
    path: '/OrderManagement',
    component: OrderManagement
  },
  {
    // M262014 【2310】供应商：订单查询响应
    path: '/OrderManagement2310',
    component: OrderManagement2310
  },
  {
    // M294001 上游：总务订单查询响应
    path: '/OrderWithUpstreamManagement',
    component: OrderWithUpstreamManagement
  },
  {
    // M29405 上游：总务订单明细查询
    path: '/OrderDetailWithUpstreamQuery',
    component: OrderDetailWithUpstreamQuery
  }
];
